<template>
  <div class="iconlist">
    <div
      v-if="iconlistTitle || iconlistDescription"
      class="iconlist-intro"
    >
      <h2 v-if="iconlistTitle">
        {{ iconlistTitle }}
      </h2>
      <p v-if="iconlistDescription">
        {{ iconlistDescription }}
      </p>
    </div>
    <ul class="iconlist-list">
      <li
        v-for="(icon, i) in iconlist"
        :key="i"
        class="iconlist-list-item"
      >
        <img
          v-if="icon.image"
          class="iconlist-list-image"
          :src="icon.image"
          alt=""
        >
        <h3
          v-if="icon.title"
          class="iconlist-list-title h4"
        >
          {{ icon.title }}
        </h3>
        <p
          v-if="icon.description"
          class="iconlist-list-description"
        >
          {{ icon.description }}
        </p>
      </li>
    </ul>
    <div>
      <KfButtonContainer
        v-if="links && links.length > 0"
        :button-container-links="links"
        :button-container-position-horizontal="btnAlignmentHorizontal"
        button-container-alignment="center"
      />
    </div>
  </div>
</template>

<script>
import KfButtonContainer from '@/components/button-container/ButtonContainer.vue';

export default {
  name: 'KfHighlightsList',
  components:{
      KfButtonContainer,
  },
  props: {
    iconlistTitle: {
      type: String,
      default: '',
    },
    iconlistDescription: {
      type: String,
      default: '',
    },
    iconlist: {
      type: Array,
      default: () => [],
    },
    links:{
      type:Array,
      default:null,
    },
    btnAlignmentHorizontal: {
      type: Boolean,
      default: false,
    }
  },
};
</script>

<style lang="postcss">
.iconlist {
  &-intro {
    @apply text-center mb-5;

    @screen md {
      @apply mb-12;
    }

    *:last-child {
      @apply mb-0;
    }
  }

  &-list {
    @apply grid grid-cols-1 justify-center gap-12 pb-8;
    max-width: calc(100% - 24px);
    margin: 0 auto;

    @screen sm {
      @apply grid grid-cols-2;
    }

    @screen md {
      @apply flex flex-row flex-wrap;
    }

    &-item {
      @apply flex flex-col flex-wrap text-center justify-start;
      flex-shrink: 0;
    }
  }

  .iconlist-list-image {
    @apply mb-7 w-32 h-32 mx-auto;
  }

  .iconlist-list-title {
    @apply mb-2 text-black text-center;


    @screen md {
      max-width: 120px;
    }
  }

  .iconlist-list-description {
    @apply text-center text-base;
  }
}
</style>
